import React from "react";
import Img from "gatsby-image";
import Helmet from "react-helmet";

import HalfScreenParallaxHero from "../components/HalfScreenParallaxHero";
import HeadingDescription from "../components/HeadingDescription";
import ThreeFeaturesRow from "../components/ThreeFeaturesRow";
import TrailingIcon from "../components/TrailingIcon";
import SplitImageTop, { splitImg } from "../components/SplitImageTop";
import SplitImageBottom from "../components/SplitImageBottom";
import KeyPerson from "../components/KeyPerson";
import Divider from "../components/Divider";
import ParallaxDivider from "../components/ParallaxDivider";

import numberLabel1 from "./../images/mb/about/label-numbers-about01.png";
import numberLabel2 from "./../images/mb/about/label-numbers-about02.png";
import numberLabel3 from "./../images/mb/about/label-numbers-about03.png";

class aboutPage extends React.Component {
  render() {
    const dataql = this.props.data;
    const acf = this.props.data.wordpressPage.acf;

    return (
      <div className="wow fadeIn">
        <Helmet title="About | Moon Beyond Co" />
        <HalfScreenParallaxHero
          title={this.props.data.wordpressPage.title}
          bg={dataql.headerBG.resolutions.src}
          symbol={acf.symbol.localFile.childImageSharp.sizes.src}
        />
        <div>
          <div className="dividerHolder">
            <div className="container">
              <div className="row aboutHeadingSection">
                <div className="col-sm-12 text-center heading">
                  <h2 className="headingSubtitle">Moon Beyond Creative</h2>
                  <HeadingDescription
                    heading="Embarking With Us"
                    description={acf.crew_description}
                  />
                </div>
              </div>

              <ThreeFeaturesRow
                features={acf.three_strengths}
                skillOrStrength="strength"
              />
              <Divider color="orange" />
            </div>
            {/* end container */}
          </div>
          {/* END First Section */}

          {/* Crew Section */}
          <SplitImageTop
            img={dataql.splitImgTop}
            heading={acf.crew_heading}
            subheading={acf.crew_subheading}
            numberLabel={dataql.numberLabel1.sizes.src}
          />

          <section className="crewSection sectionLargeHeading">
            <div className="container text-center">
              <div className="row offers text-center">
                {acf.crew.map((a, i) => {
                  return (
                    <KeyPerson
                      key={i}
                      img={a.member_image.localFile.childImageSharp}
                      name={a.member_name}
                      description={a.member_description}
                    />
                  );
                })}
              </div>
              <div className="row crewDescription">
                <div className="col-xs-12">
                  <p
                    dangerouslySetInnerHTML={{ __html: acf.crew_description }}
                  />
                </div>
              </div>
              {/* Tab Row */}
              <div className="row tabContainer">
                <div className="col-md-7 col-sm-12 center-col">
                  {/* tab */}
                  <div className="tab-style1">
                    <div className>
                      {/* tab navigation */}
                      <ul className="nav nav-tabs nav-tabs-light text-left">
                        {acf.mission_statement_tab_section.map((a, i) => {
                          return (
                            <li className={i === 0 ? "active" : null} key={i}>
                              <a href={`#tab_sec${i + 1}`} data-toggle="tab">
                                {a.tab_name}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                      {/* tab end navigation */}
                    </div>
                    {/* tab content section */}
                    <div className="tab-content">
                      {/* tab content */}
                      {acf.mission_statement_tab_section.map((a, i) => {
                        return (
                          <div
                            key={i}
                            className={`tab-pane med-text fade in ${
                              i === 0 ? "active" : ""
                            }`}
                            id={`tab_sec${i + 1}`}
                          >
                            <div className="text-left">
                              <div
                                className="twoColumns"
                                dangerouslySetInnerHTML={{
                                  __html: a.left_column
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                      {/* end tab content */}
                    </div>
                    {/* end tab content section */}
                  </div>
                  {/* end tab */}
                </div>
              </div>
              {/* End Tab Row */}
            </div>
          </section>
          {/* END Crew Section */}

          <ParallaxDivider
            tagline={acf.parallax_section_text}
            taglineColor="#fff"
            bg={acf.parallax_section_image.localFile.childImageSharp.sizes.src}
            trailingElementColor="black"
          />
          <Divider color="black" />

          {/* Clients Section */}
          <div className="clientsSection sectionLargeHeading">
            <div className="container text-center">
              <div className="row headingSection">
                <div className="col-xs-12 headingLargeElement">
                  <h1>
                    <img src={dataql.numberLabel3.sizes.src} />
                    {acf.meet_the_clients_heading}
                  </h1>
                  <h2>{acf.meet_the_clients_subheading}</h2>
                </div>
              </div>

              <div
                className="row offers text-center"
                style={{ marginBottom: 150 }}
              >
                {acf.meet_the_clients_columns.map((a, i) => (
                  <div
                    key={i}
                    className="col-sm-4 text-center wow fadeIn features-2"
                    data-wow-duration="300ms"
                  >
                    <p
                      dangerouslySetInnerHTML={{
                        __html: a.column_text
                      }}
                    />
                  </div>
                ))}
              </div>
              <TrailingIcon img={dataql.trailingIcon} />
            </div>
          </div>
          {/* END Clients Section */}
          <SplitImageBottom
            img={dataql.splitImgBottom}
            blurb={acf.next_page_blurb}
            link="../Services"
            linkText={acf.next_page_button_text}
          />
        </div>
      </div>
    );
  }
}

export default aboutPage;

export const query = graphql`
  query aboutPageQuery {
    wordpressPage(title: { eq: "About" }) {
      title
      acf {
        symbol {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                src
              }
            }
          }
        }
        split_image_top {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                ...GatsbyImageSharpSizes_noBase64
              }
            }
          }
        }
        split_image_bottom {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                ...GatsbyImageSharpSizes_noBase64
              }
            }
          }
        }
        next_page_blurb
        next_page_button_text
        next_page_link
        title
        first_heading
        section_1_text
        subtitle
        crew_heading
        crew_subheading
        crew_description
        crew {
          member_name
          member_title
          member_description
          member_image {
            localFile {
              childImageSharp {
                resolutions(width: 200) {
                  ...GatsbyImageSharpResolutions_noBase64
                }
              }
            }
          }
        }
        mission_statement_tab_section {
          tab_name
          left_column
        }
        mission_statement_heading
        meet_the_clients_heading
        mission_statement_subheading
        meet_the_clients_subheading
        meet_the_clients_columns {
          column_text
        }
        parallax_section_text
        parallax_section_image {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920, quality: 80) {
                src
              }
            }
          }
        }
        mission_statement_description
        three_strengths {
          strength_name
          strength_description
          strength_image {
            localFile {
              childImageSharp {
                resolutions(width: 200) {
                  ...GatsbyImageSharpResolutions_noBase64
                }
              }
            }
          }
        }
        three_skills {
          skill_name
          skill_desc
        }
      }
    }

    

    trailingIcon: imageSharp(id: { regex: "/trailing_icon_about.png/" }) {
      resolutions(width: 350) {
        src
        srcSet
      }
    }

    splitImgTop: imageSharp(id: { regex: "/mb/about_split_top.png/" }) {
      ...SplitImg
    }
    splitImgBottom: imageSharp(id: { regex: "/mb/about_split_bottom.png/" }) {
      ...SplitImg
    }

    headerBG: imageSharp(id: { regex: "/mb/about_header2.png/" }) {
      ...HeaderBG
    }

    numberLabel1: imageSharp(id: { regex: "/mb/about/label-numbers-about01.png/" }) {
      sizes(maxWidth: 198) {
        src
      }
    }

    numberLabel2: imageSharp(id: { regex: "/mb/about/label-numbers-about02.png/" }) {
      sizes(maxWidth: 198) {
        src
      }
    }

    numberLabel3: imageSharp(id: { regex: "/mb/about/label-numbers-about03.png/" }) {
      sizes(maxWidth: 198) {
        src
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/about.js